var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('pageInnerHeaderComponent',{attrs:{"lang":_vm.lang,"title":'pages.integrations'}}),_c('integrationListCompoenent',{attrs:{"lang":_vm.lang,"title":'pages.integrations'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }